<template>
  <div :class="iconDivClasses">
    <SvgIcon
      :class="isContentspot ? 'w-6 h-6' : 'w-3 h-5'"
      :icon="iconSlug"
    />
  </div>
</template>

<script>
import SvgIcon from '@/components/SvgIcon.vue'

export default {
  name: 'HotspotDemo',

  components: {
    SvgIcon
  },

  props: {
    typeStyles: {
      type: Object,
      default: () => {}
    },
    isContentspot: {
      type: Boolean,
      default: null
    },
    iconSlug: {
      type: String,
      default: ''
    },
  },

  computed: {
    iconDivClasses() {
      const iconStyles = this.typeStyles ? this.typeStyles.icon : {}
      const focusStyles = iconStyles.focus ?? false
      const hoverStyles = iconStyles.hover ?? false
      if (!iconStyles || !focusStyles || !hoverStyles) { return }
      // Return
      return [
        'w-10_5 h-10_5',
        'flex-c flex-shrink-0',
        'rounded-full',
        `border-${iconStyles.border_color} border-${iconStyles.border_width}`,
        `group-focus:border-${focusStyles.border_color} lg:group-hover:border-${hoverStyles.border_color}`,
        `bg-${iconStyles.bg_color}`,
        `group-focus:bg-${focusStyles.bg_color} lg:group-hover:bg-${hoverStyles.bg_color}`,
        `fill-${iconStyles.fill_color}`,
        `group-focus:fill-${focusStyles.fill_color} lg:group-hover:fill-${hoverStyles.fill_color}`,
        'transition-colors duration-500 ease-in-out'
      ]
    }
  }
}
</script>
